const serializePart = (value: unknown): string => {
    if (value === null || value === undefined) {
        return '';
    }

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }

    if (Array.isArray(value)) {
        return `[${value.map(serializePart).join(',')}]`;
    }

    if (typeof value === 'object') {
        const entries = Object.entries(value as Record<string, unknown>).sort(([a], [b]) => a.localeCompare(b));
        return `{${entries.map(([key, val]) => `${key}:${serializePart(val)}`).join(',')}}`;
    }

    return String(value);
};

export const createStableClassToken = (prefix: string, parts: unknown[]): string => {
    const raw = `${prefix}:${parts.map(serializePart).join('|')}`;
    let hash = 0;

    for (let index = 0; index < raw.length; index += 1) {
        hash = (hash * 31 + raw.charCodeAt(index)) % 2147483647;
    }

    return `${prefix}-${Math.abs(hash).toString(36)}`;
};
